var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"documents-enlarge-graph radius-box-8 padding-box-16"},[_c('h2',[_vm._v("¿Cómo vamos con los documentos?")]),_vm._m(0),_c('div',{staticClass:"link"},[_c('a',{on:{"click":function($event){return _vm.onclick()}}},[_vm._v("CLIC PARA AMPLIAR")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("../../../assets/img/graph-small.png")}})])
}]

export { render, staticRenderFns }